import { render, staticRenderFns } from "./detialFrom.vue?vue&type=template&id=175f1503&"
import script from "./detialFrom.vue?vue&type=script&lang=js&"
export * from "./detialFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports